import React, { useState, useEffect, useRef } from 'react';
import SignatureCanvas from "react-signature-canvas";
import {useNavigate} from "react-router-dom";

export default function FirstStep({ tabMoving, setTabMoving, setSnackbarTxt, signature, setSignature, tab, setTab, setUserName, userName, exbtPlcHandler, selectedExbtPlcList, evntList }: any) {
    const noEvntMsg = 'Today No Event'
    const userNmRef = useRef<any>();
    const mouseDownRef = useRef<any>();
    const signCanvas = useRef(null) as React.MutableRefObject<any>;
    const [exampleHide, setExampleHide] = useState(false);

    const fn_clear = () => {
        !tabMoving && signCanvas.current.clear();
    }

    const clear = () => {
        setTabMoving(false);
        setSignature('');
        setExampleHide(false);
        fn_clear();
    }

    useEffect(() => {
        // 이벤트 핸들러 함수
        const handler = (e: any) => {
            // mousedown 이벤트가 전자서명 창에서만 반응하도록
            if (mouseDownRef.current && mouseDownRef.current.contains(e.target)) {
                setExampleHide(true);
            }
        };
        // 이벤트 핸들러 등록
        document.addEventListener('mousedown', handler);
        document.addEventListener('touchstart', handler); // 모바일 대응
        return () => {
            // 이벤트 핸들러 해제
            document.removeEventListener('mousedown', handler);
            document.removeEventListener('touchstart', handler); // 모바일 대응
        };
    });

    const saveSignature = () => {
        setSignature(signCanvas.current.toDataURL("image/webp"));
    }

    const getPlaceNameProperties = (hallName: string) => {
        return `w-[45%] py-[20%] border rounded-[7px] md:rounded-[17px] flex flex-col justify-center items-center font-preBold text-32 md:text-[125px] ${selectedExbtPlcList.includes(hallName) ? 'border-point text-point' : 'border-[#B1B1B1] text-[#B1B1B1]'} `;
    }

    const fn_nextTab = () => {
        if(tab === 0 && userName === '') {
            setSnackbarTxt('Please input your name.');
            return;
        }
        if (tab === 0 && (!signature ||
            signature === 'data:image/webp;base64,UklGRjYDAABXRUJQVlA4WAoAAAAgAAAALwIAGQEASUNDUMgBAAAAAAHIAAAAAAQwAABtbnRyUkdCIFhZWiAAAAAAAAAAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAACRyWFlaAAABFAAAABRnWFlaAAABKAAAABRiWFlaAAABPAAAABR3dHB0AAABUAAAABRyVFJDAAABZAAAAChnVFJDAAABZAAAAChiVFJDAAABZAAAAChjcHJ0AAABjAAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAHMAUgBHAEJYWVogAAAAAAAAb6IAADj1AAADkFhZWiAAAAAAAABimQAAt4UAABjaWFlaIAAAAAAAACSgAAAPhAAAts9YWVogAAAAAAAA9tYAAQAAAADTLXBhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABtbHVjAAAAAAAAAAEAAAAMZW5VUwAAACAAAAAcAEcAbwBvAGcAbABlACAASQBuAGMALgAgADIAMAAxADZWUDggSAEAABAlAJ0BKjACGgE+bTaZSaQjIqEgCACADYlpbuF3YRtACewD32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+sAAP7/6NAAAAAAAAAAAAAAAAAAAAAAAAA='
        )) {
            setSnackbarTxt('Please sign inside the square.');
            return;
        }
        if (tab === 0 && signature) { setTabMoving(true); }
        setTab(tab + 1)
    }

    return (
        <div className='bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center overflow-auto scrollbar-hide h-[calc(100%-117px)] md:h-[calc(100%-435px)]'>
            {tab === 0 && <div className='w-[87%] md:w-[750px] mb-20 md:mb-[50px]'>
                {/* {`${(tab === 0 || tab === 1) ? 'sm:w-[75%]' : 'sm:w-[87%]'}  */}
                <p className='text-18 leading-[18px] md:text-37 md:leading-[45px] mt-50 md:mt-[90px]'>User name</p>
                <input ref={userNmRef} value={userName} onChange={(e) => setUserName(e.target.value)}
                       className='mt-20 md:mt-[50px] w-full h-43 md:h-[107px] pl-5 md:pl-[12px] outline-none border border-[0.5px] border-[#a8a8a8] rounded-[5px] md:rounded-[12px] font-preLight'
                       type='text'/>
                <p className='text-18 leading-[18px] mt-30 md:text-37 md:leading-[45px] md:mt-[75px]'>Signature</p> {/* <span className='text-point'>*</span> */}
                <div className='flex justify-between items-center mt-7 mb-7 md:mt-[30px] md:mb-[25px]'>
                    <p className='font-preLight text-15 md:text-45 text-txtBlack'>Write your name in the square.</p>
                    <div onClick={clear}
                         className='hover:cursor-pointer w-72 sm:w-92 md:w-[230px] bg-[#E4E4E4] flex items-center justify-center rounded-[5px] md:rounded-[12px] text-18 md:text-37 text-[#9C9C9B] font-preLight py-3 md:py-10'>
                        retry
                    </div>
                </div>
                <div ref={mouseDownRef}>
                    {tabMoving
                        ? <img src={signature} alt=""
                               className='w-full h-141 md:h-[352px] rounded-[5px] md:rounded-[12px] border border-[#D9D9D9]'/>
                        : <SignatureCanvas
                            ref={signCanvas}
                            canvasProps={{className: `${exampleHide ? '' : `bg-[url('./images/signExample.png')]`} w-[255px] sm:w-[308px] md:w-[750px] h-141 md:h-[352px] border border-[#E4E4E4] rounded-[5px] md:rounded-[12px] z-[999]`}}
                            backgroundColor="transparent"
                            onEnd={saveSignature}
                        />}
                </div>
                <button onClick={fn_nextTab}
                        className='text-white mt-15 md:mt-[45px] text-17 md:text-32 leading-18 md:leading-36 w-full py-[0.8rem] md:py-[30px] outline-none rounded-[5px] md:rounded-[12px] bg-gradient-to-r from-gdFrom to-gdTo whitespace-pre'>
                    confirmed that the electronic{'\n'}signature written is effective.
                </button>
            </div>}
            {tab === 1 && <div className='flex flex-col mt-15 md:mt-[37px]'>
                <p className='mt-35 ml-8 font-preBold text-17 md:ml-[20px] md:text-42'>Please select a place where you
                    work.</p>
                <p className='ml-8 font-preLight text-15 md:ml-[20px] md:text-37'>(Multiple choices available)</p>
                <div className='flex justify-between mt-20 mx-10 md:mt-[50px] md:mx-[50px]'>
                    <div onClick={() => evntList['전시장1'] && exbtPlcHandler('전시장1', evntList['전시장1'].evntSeq)}
                         className={getPlaceNameProperties('전시장1')}>
                        <p className={evntList['전시장1'] ? 'text-13 font-preBold w-[83%] leading-17 md:text-[32px] md:leading-[42px]' : 'text-14 font-preLight whitespace-pre-wrap leading-17 md:text-[35px] md:leading-[42px]'}>
                            {!evntList['전시장1'] && noEvntMsg}</p>
                        <p>HALL 1</p>
                    </div>
                    <div onClick={() => evntList['전시장2'] && exbtPlcHandler('전시장2', evntList['전시장2'].evntSeq)}
                         className={getPlaceNameProperties('전시장2')}>
                        <p className={evntList['전시장2'] ? 'text-13 font-preBold w-[83%] leading-17 md:text-[32px] md:leading-[42px]' : 'text-14 font-preLight whitespace-pre-wrap leading-17 md:text-[35px] md:leading-[42px]'}>
                            {!evntList['전시장2'] && noEvntMsg}</p>
                        <p>HALL 2</p>
                    </div>
                </div>
                <button onClick={fn_nextTab}
                        className='text-white mt-25 md:mt-[45px] text-17 md:text-32 leading-18 md:leading-36 w-full py-[0.8rem] md:py-[30px] outline-none rounded-[5px] md:rounded-[12px] bg-gradient-to-r from-gdFrom to-gdTo whitespace-pre'>
                    TBM start
                </button>
            </div>}
        </div>);
}
